import React from "react"
import * as S from "./elements"
import { Box } from "@components/Layout"
import { GridTemplateColumnsProps, MaxWidthProps } from "styled-system"
import { rem } from "polished"

interface Props extends GridTemplateColumnsProps, MaxWidthProps {
  label: string
  sublabel?: string
}

const FieldControl: React.FC<Props> = ({
  label,
  sublabel,
  children,
  maxWidth = ["100%", rem(180)],
  gridTemplateColumns,
  ...rest
}) => {
  return (
    <S.Row>
      <Box
        height={["auto", "2.75rem"]}
        display="flex"
        alignItems="center"
        flexWrap="wrap"
        py={2}
      >
        <S.Label>{label}</S.Label>
        {sublabel && <S.Sublabel>{sublabel}</S.Sublabel>}
      </Box>
      <Box
        display="grid"
        gridColumnGap=".5rem"
        maxWidth={maxWidth}
        style={{ gridAutoFlow: "column dense" }}
        gridTemplateColumns={gridTemplateColumns}
        {...rest}
      >
        {children}
      </Box>
    </S.Row>
  )
}

export default FieldControl
